<template>
  <section>
    <fieldset v-for="field in stepDatas($route.name)" :key="field.name">
      <label :for="field.name">
        <input
          v-if="field.type === 'checkbox'"
          type="checkbox"
          :name="field.name"
          :checked="field.value"
          @change="updateCheckboxValue($event, field.name)"/>
        {{field.label}}
      </label>

      <input
        min="0"
        v-if="['tel', 'number', 'email'].includes(field.type)"
        :title="field.label"
        :id="field.name"
        :type="field.type"
        :value="field.value"
        :required="field.required"
        :placeholder="field.placeholder"
        :pattern="field.type === 'number' ? '[0-9]*' : false"
        :inputmode="field.type === 'number' ? 'numeric' : false"
        @input="updateValue($event, field.name)">

      <textarea
        v-if="field.type === 'textarea'"
        rows="1"
        :id="field.name"
        :placeholder="field.placeholder"
        :value="field.value"
        maxlength="200"
        @input="updateValue($event, field.name)"/>
    </fieldset>

    <fieldset>
      <small>* Champ obligatoire</small>
      <small class="help app">
        <a href="https://www.allianz.fr/assurance-auto/mon-releve-kilometrique" target="_blank">Une question, un problème ? Cliquez ici</a>
      </small>
    </fieldset>
  </section>
</template>

<script>
  import autosize from 'autosize'
  import debounce from 'lodash/debounce'
  import { mapGetters } from 'vuex'

  export default {
    computed: mapGetters(['stepDatas']),
    mounted() {
      // Resize textareas on input
      autosize(this.$el.querySelectorAll('textarea'))
    },
    methods: {
      updateCheckboxValue: function(e, name) {
        const event = {
          target: {
            value: e.target.checked
          }
        }
        this.updateValue(event, name)
      },
      updateValue: debounce(function(e, name) {
        this.$store.dispatch('updateValue', {
          name,
          value: e.target.value
        })
      }, 300, {
        leading: true,
        trailing: true,
      })
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/_vars.scss';

  fieldset {
    appearance: none;
    margin: spacer() auto;
    padding: 0 spacer();
    border: none;
    max-width: 30rem;
  }

  label {
    display: inline-block;
  }

  input, textarea {
    appearance: none;
    display: block;
    width: 100%;
    font: inherit;
    border: none;
    border-bottom: 1px solid rgba(color('text'),.15);
    padding: 0 0 1em;
    margin: 0;
    resize: none;
    border-radius: 0;
  }

  input[type="checkbox"] {
    appearance: auto;
    width: auto;
    display: inline-block;
    margin-right: 5px;
  }

  textarea {
    min-height: 5em;
  }

  small {
    display: block;
    font-size: .9em;
    opacity: .5;
  }

  .help {
    &.app {
      text-align: left;
      width: 100%;
      display: block;
      margin-top: 5px;

      a {
        color: #00a9e0;
        font-size: 1.2em;
        text-decoration: none;
        margin-left: 8px;
      }
    }
  }
</style>
